import { useState } from 'react'

import AddIcon from '@mui/icons-material/Add'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

import type { FilterOption } from '@models/Filter'
import type { GebiedLabel } from '@models/GebiedLabel'

import type { AuthenticatedUser } from '../../auth/types/AuthenticatedUser'

import { CreateGebiedLabel } from './dialogs/CreateGebiedLabel'

export { CreateGebiedLabelButton }

type Props = {
  user: AuthenticatedUser
  projectType: GebiedLabel['projectType']
  verantwoordelijke: string
  gebieden: FilterOption[]
}

const CreateGebiedLabelButton = ({
  user,
  projectType,
  verantwoordelijke,
  gebieden,
}: Props) => {
  const { canViewBeheer, canCreateLabel } = user
  const [open, setOpen] = useState(false)

  if (!canViewBeheer || !canCreateLabel) {
    return null
  }

  return (
    <Box sx={{ display: 'flex', marginBottom: 2, justifyContent: 'end' }}>
      <Button
        variant="contained"
        endIcon={<AddIcon />}
        onClick={() => setOpen(true)}
      >
        Label in nieuw gebied toevoegen
      </Button>

      <CreateGebiedLabel
        open={open}
        setOpen={setOpen}
        projectType={projectType}
        verantwoordelijke={verantwoordelijke}
        gebieden={gebieden}
      />
    </Box>
  )
}
